import React from 'react';
import PropTypes from 'prop-types';
import { cx } from 'emotion';
import { componentWrapStyle, componentDropDownStyle, componentBadgeStyle } from './styles';

class FilterDropDownComponent extends React.PureComponent {
	constructor({ manager }) {
		super();
		this.anchor = null;
		this.sheet = null;
		this.state = {
			open: false,
			anchorEl: null,
			manager: manager,
		};
	}

	calculateTop() {
		return (
			this.state.anchorEl.getBoundingClientRect().top +
			this.state.anchorEl.offsetHeight +
			window.scrollY
		);
	}

	componentDidMount() {
		window.addEventListener('mousedown', this.didClickWindow);
		if (this.sheet) {
			this.sheet.addEventListener('mousedown', this.didClickSheet);
		}
		if (this.anchor) {
			this.anchor.addEventListener('mousedown', this.didClickSheet);
		}
		let filterId = Math.random() * 99999;
		this.setState({
			anchorEl: document.querySelector(this.props.anchorTo),
			filterId: filterId,
		});
		if (this.state.manager) {
			this.state.manager.subscribe({
				id: filterId,
				hide: () => {
					this.setState({ open: false });
				},
			});
		}
	}

	componentWillUnmount() {
		window.removeEventListener('mousedown', this.didClickWindow);
		if (this.sheet) {
			this.sheet.removeEventListener('mousedown', this.didClickSheet);
		}
		if (this.anchor) {
			this.anchor.removeEventListener('mousedown', this.didClickSheet);
		}
		if (this.state.manager) {
			this.state.manager.unsubscribe(this.state.filterId);
		}
	}

	didClickWindow = () => {
		if (!this.state.open) return;
		this.close();
	}

	didClickSheet = (e) => {
		if (!this.state.open) return;
		e.stopPropagation();
	}

	close = () => {
		this.setState({
			open: false
		});
	}

	render() {
		let { componentName, className, hasBadge } = this.props;
		return (
			<div
				className={cx(componentWrapStyle(this.state.open), className)}
				data-component="FilterDropDown">
				<a
					href="#"
					ref={ref => (this.anchor = ref) }
					onClick={e => {
						e.preventDefault();
						this.setState({
							open: !this.state.open,
							top: this.calculateTop(),
						});
					}}>
					{ componentName }
					{ hasBadge && (
						<span className={ componentBadgeStyle }/>
					) }
				</a>
				<div className={ componentDropDownStyle(this.state.top) } ref={ref => (this.sheet = ref) }>
					{ this.props.children }
				</div>
			</div>
		);
	}
}

FilterDropDownComponent.propTypes = {
	componentName: PropTypes.string,
	anchorTo: PropTypes.string,
	className: PropTypes.string,
	hasBadge: PropTypes.bool,
	// TODO: Make more explicit
	children: PropTypes.any,
	manager: PropTypes.object,
};

export const FilterDropDown = FilterDropDownComponent;



// WEBPACK FOOTER //
// ./src/components/shared/filterDropDown/component.js